import React, { useState } from 'react'
import { Row, Col } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import moment from 'moment'

import SelectAdvanced from './SelectAdvanced'
import HandleRow from './HandleRow'

const RowAdvanced = ({ row, rowIndex, removeRow, setNoUsersText, removePreview, updateRows, filters, advancedFilters }) => {
  const [type, setType] = useState('')
  const [option, setOption] = useState('')

  const { key: rowKey, columns } = row

  /** Handle filter when date changes */
  const handleDateChange = (data, colIndex) => {
    setNoUsersText(false)
    removePreview()

    const date = moment(data).format('YYYY-MM-DD')

    // check if it is an update
    const { value: oldValue } = columns[2]
    if (oldValue.length) {
      updateRows({
        type: columns[0].value,
        option: columns[1].value,
        value: oldValue,
        action: 'replace',
        newValue: date,
      })
    } else {
      updateRows({
        type,
        option,
        value: date,
      })
    }
    columns[2].label = date
    columns[2].value = date
  }

  /** Define column filter */
  const setColValue = ({ label, value }, { name }) => {
    setNoUsersText(false)
    removePreview()

    switch (name) {
      case 'type': {
        const { value: oldType } = columns[0]
        const { value: oldOption } = columns[1]
        const { value: oldValue } = columns[2]

        if (oldOption.length && oldValue.length) {
          updateRows({
            type: type.length ? type : oldType,
            option: oldOption,
            value: oldValue,
            action: 'remove',
          })
        }

        setType(value)
        columns.forEach((col, i) => {
          col.value = i === 0 ? value : ''
          col.label = i === 0 ? label : ''
          col.type = i === 2 && (value === 'createdAt' || value === 'updatedAt') ? 'date' : ''
        })

        getNextColOptions(value)
        break
      }
      case 'option': {
        const { value: oldOption } = columns[1]
        const { value: oldValue } = columns[2]

        setOption(value)

        if (oldOption.length) {
          columns[2].value = ''
          columns[2].label = ''

          updateRows({
            type,
            option: oldOption,
            value: oldValue,
            action: 'remove',
          })
        }

        columns[1].value = value
        columns[1].label = label
        break
      }
      case 'value': {
        const { value: oldValue } = columns[2]

        columns[2].value = value
        columns[2].label = label

        if (oldValue.length) {
          updateRows({
            type,
            option,
            value: oldValue,
            action: 'replace',
            newValue: value,
          })
        } else {
          updateRows({ type, option, value })
        }
        break
      }
      default:
        return
    }
  }

  // Define options for column 1 and 2
  const getNextColOptions = (type) => {
    const countCreatedAt = advancedFilters.filters.filter((obj) => obj.type === 'createdAt').length
    const countUpdatedAt = advancedFilters.filters.filter((obj) => obj.type === 'updatedAt').length

    if (type === 'createdAt' || type === 'updatedAt') {
      if (countCreatedAt === 1 && type === 'createdAt') {
        columns[1].options = [{ label: `${I18n.t('dashboard_until')}`, value: 'until' }]
      } else if (countUpdatedAt === 1 && type === 'updatedAt') {
        columns[1].options = [{ label: `${I18n.t('dashboard_until')}`, value: 'until' }]
      } else {
        columns[1].options = [{ label: `${I18n.t('dashboard_from')}`, value: 'from' }]
      }
      columns[2].type = 'date'
    } else {
      columns[1].options = [
        { label: `${I18n.t('dashboard_is')}`, value: 'is' },
        { label: `${I18n.t('dashboard_its-not')}`, value: 'isnot' },
      ]
      const thirdOptions = filters[type].map((el) => ({
        label: type === 'states'
          ? I18n.t(`states_${el.label}`)
          : type === 'channels'
            ? I18n.t(`channels_${el.label}`)
            : el.label,
        value: el.value,
      }))
      columns[2].options = thirdOptions
    }
    return
  }

  const onRemoveRow = () => {
    removeRow(rowKey)
    removePreview()
    setType('')
    setOption('')
    return
  }

  return (
    <Row form key={`${rowIndex}${rowKey}${rowIndex}`}>
      <Col md={11} className={'row-advanced'}>
        {columns.map((col, index) => {
          return (
            <SelectAdvanced
              key={index}
              rowKey={rowKey}
              options={col.options}
              defaultValue={col.value ? { label: col.label, value: col.value } : null}
              name={col.name}
              colType={col.type}
              colIndex={index}
              onChange={col.type === 'date' ? handleDateChange : setColValue}
              colValue={col.value}
            />
          )
        })}
      </Col>
      <Col>
        <HandleRow handleClick={onRemoveRow} spanClassName={'minus-condition-text'} type={'minus'} />
      </Col>
    </Row>
  )
}

export default RowAdvanced
